import { addFilter } from "@wordpress/hooks";
import { createHigherOrderComponent } from "@wordpress/compose";
import {
    PanelBody,
    __experimentalView as View,
    RangeControl,
    TabPanel,
    Icon,
} from "@wordpress/components";
import { InspectorControls } from "@wordpress/block-editor";
import { Fragment, useState } from "@wordpress/element";
import { desktop, mobile, tablet } from "@wordpress/icons";

// Dodajemy nowe atrybuty do bloku Column
function addOrderAttributes(settings, name) {
    if (name !== "core/column") {
        return settings;
    }

    return {
        ...settings,
        attributes: {
            ...settings.attributes,
            orderDesktop: {
                type: "number",
                default: 0,
            },
            orderTablet: {
                type: "number",
                default: 0,
            },
            orderMobile: {
                type: "number",
                default: 0,
            },
        },
    };
}

// Dodajemy kontrolki do panelu inspektora
const withOrderControls = createHigherOrderComponent((BlockEdit) => {
    return function WithOrderControls(props) {
        if (props.name !== "core/column") {
            return <BlockEdit {...props} />;
        }

        const { attributes, setAttributes } = props;

        // Dodajemy style bezpośrednio do bloku w edytorze
        const blockProps = {
            ...props,
            style: {
                ...props.style,
                order: Number(attributes.orderDesktop),
            },
        };

        return (
            <Fragment>
                <BlockEdit {...blockProps} />
                <InspectorControls>
                    <PanelBody
                        title="Kolejność wyświetlania"
                        initialOpen={false}
                    >
                        <TabPanel
                            className="custom-settings-tab"
                            activeClass="active-tab"
                            tabs={[
                                {
                                    name: "desktop",
                                    title: "Desktop",
                                    icon: desktop,
                                },
                                {
                                    name: "tablet",
                                    title: "Tablet",
                                    icon: tablet,
                                },
                                {
                                    name: "mobile",
                                    title: "Mobile",
                                    icon: mobile,
                                },
                            ]}
                        >
                            {(tab) => (
                                <View style={{ padding: "15px 0" }}>
                                    {tab.name === "desktop" && (
                                        <RangeControl
                                            label="Kolejność - Desktop"
                                            value={Number(
                                                attributes.orderDesktop
                                            )}
                                            onChange={(value) =>
                                                setAttributes({
                                                    orderDesktop: Number(value),
                                                })
                                            }
                                            min={0}
                                            max={10}
                                        />
                                    )}
                                    {tab.name === "tablet" && (
                                        <RangeControl
                                            label="Kolejność - Tablet"
                                            value={Number(
                                                attributes.orderTablet
                                            )}
                                            onChange={(value) =>
                                                setAttributes({
                                                    orderTablet: Number(value),
                                                })
                                            }
                                            min={0}
                                            max={10}
                                        />
                                    )}
                                    {tab.name === "mobile" && (
                                        <RangeControl
                                            label="Kolejność - Mobile"
                                            value={Number(
                                                attributes.orderMobile
                                            )}
                                            onChange={(value) =>
                                                setAttributes({
                                                    orderMobile: Number(value),
                                                })
                                            }
                                            min={0}
                                            max={10}
                                        />
                                    )}
                                </View>
                            )}
                        </TabPanel>
                    </PanelBody>
                </InspectorControls>
            </Fragment>
        );
    };
}, "withOrderControls");

// Dodajemy style do kolumny
const addOrderStyles = (extraProps, blockType, attributes) => {
    if (blockType.name !== "core/column") {
        return extraProps;
    }

    const styles = {
        ...extraProps.style,
    };

    if (
        attributes.orderDesktop ||
        attributes.orderTablet ||
        attributes.orderMobile
    ) {
        styles["--order-desktop"] = `${attributes.orderDesktop}`;
        styles["--order-tablet"] = `${attributes.orderTablet}`;
        styles["--order-mobile"] = `${attributes.orderMobile}`;

        extraProps.className = extraProps.className
            ? `${extraProps.className} has-custom-order`
            : "has-custom-order";
    }

    extraProps.style = styles;

    return extraProps;
};

// Rejestrujemy filtry
addFilter(
    "blocks.registerBlockType",
    "custom/order/add-attributes",
    addOrderAttributes
);
addFilter("editor.BlockEdit", "custom/order/add-control", withOrderControls);
addFilter(
    "blocks.getSaveContent.extraProps",
    "custom/order/add-styles",
    addOrderStyles
);
